// Typelizer digest 0d813b891ee2aa4100a229857502b2eb
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../../runtime'
import { buildUrl } from '../../runtime'

export default {
  /** POST /c/:company_id/payments/:payment_id/payments */
  create: (
    params: { paymentId: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'post'> => ({
    url: buildUrl('/c/:company_id/payments/:payment_id/payments', params, options),
    method: 'post',
  }),

  /** DELETE /c/:company_id/payments/:payment_id/payments/:id */
  destroy: (
    params: { paymentId: string | number; id: string | number },
    options?: RouteOptions,
  ): RouteDefinition<'delete'> => ({
    url: buildUrl('/c/:company_id/payments/:payment_id/payments/:id', params, options),
    method: 'delete',
  }),
}
